
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kolejne-kroki",
      function () {
        return require("private-next-pages/kolejne-kroki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kolejne-kroki"])
      });
    }
  